import React, { useState, useEffect } from 'react';
import { useAuth } from '../../utils/authService';
import { db } from '../../utils/firebase-config';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import CommunityFormSubmissions from './CommunityFormSubmissions';
import { useNavigate } from 'react-router-dom';
import updateUserProgress from '../Survey/userProgressTrack/updateUserProgress';

const UserProfile = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    firstName: '',
    lastName: '',
    displayName: '',
    email: '',
    bio: '',
    dateOfBirth: '',
    progress: {
      "Masterclass": 0,
      "Finances & Philanthropy": 0,
      "Entrepreneurship & Philanthropy": 0,
      "Community-Minded Business Concept Form": 0,
      "Wealth Building Stage": 0
    }
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState('profile'); // State for active tab

  useEffect(() => {
    const fetchUserData = async () => {
      if (user && user.uid) {
        const userDocRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(userDocRef);
        if (docSnap.exists()) {
          setUserData(docSnap.data());
        }
        setLoading(false);
      }
    };

    fetchUserData();
  }, [user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    const userDocRef = doc(db, 'users', user.uid);
    try {
      await updateDoc(userDocRef, userData);
      alert('Profile updated successfully!');
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Failed to update profile.');
    }
    setSaving(false);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  const handleStepClick = async (area, step) => {
    try {
      await updateUserProgress(user.uid, area, step);
      await updateDoc(doc(db, 'users', user.uid), { currentStep: step });

      navigate(`/survey/${step}`);
    } catch (error) {
      console.error('Failed to update progress:', error);
    }
  };

  const renderProgress = () => {
    const { progress } = userData;

    return (
      <div>
        <h3 className="text-xl font-bold mb-4">Progress</h3>
        {progress && Object.entries(progress).map(([area, step]) => (
          area !== 'undefined' && (
            <div key={area} className="mb-4">
              <label className="block text-sm font-medium text-gray-700">{area.replace(/_/g, ' ')}</label>
              <button
                onClick={() => handleStepClick(area, step)}
                className="mt-1 block w-full text-left shadow-sm sm:text-sm border-gray-300 rounded-md bg-gray-100 px-4 py-2 hover:bg-gray-200"
              >
                {`Step ${step} - ${area.replace(/_/g, ' ')}`}
              </button>
            </div>
          )
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="mb-4">
        <button onClick={() => setActiveTab('profile')} className={`px-4 py-2 ${activeTab === 'profile' ? 'bg-amber-500 text-black' : 'bg-gray-300'}`}>
          Profile
        </button>
        {/* <button onClick={() => setActiveTab('communityForms')} className={`px-4 py-2 ${activeTab === 'communityForms' ? 'bg-amber-500 text-black' : 'bg-gray-300'}`}>
          Community Form Submissions
        </button> */}
        {/* <button onClick={() => setActiveTab('progress')} className={`px-4 py-2 ${activeTab === 'progress' ? 'bg-amber-500 text-black' : 'bg-gray-300'}`}>
          Progress
        </button> */}
      </div>
      <div className="mx-auto my-10 p-6 bg-white rounded-md shadow-md">
        <h2 className="text-2xl font-bold mb-6">{activeTab === 'communityForms' ? 'Community Form Submissions' : activeTab === 'progress' ? 'You\'re currently here' : 'Adjust Profile'}</h2>

        {activeTab === 'profile' && (
          <form className="userForm">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">First Name</label>
              <input
                type="text"
                name="firstName"
                value={userData.firstName || ''}
                onChange={handleInputChange}
                className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Last Name</label>
              <input
                type="text"
                name="lastName"
                value={userData.lastName || ''}
                onChange={handleInputChange}
                className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Display Name</label>
              <input
                type="text"
                name="displayName"
                value={userData.displayName || ''}
                onChange={handleInputChange}
                className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="email"
                name="email"
                value={userData.email || ''}
                onChange={handleInputChange}
                className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">About Me</label>
              <textarea
                name="bio"
                value={userData.bio || ''}
                onChange={handleInputChange}
                className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Date of Birth</label>
              <input
                type="date"
                name="dateOfBirth"
                value={userData.dateOfBirth || ''}
                onChange={handleInputChange}
                className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <button
              type="button"
              onClick={handleSave}
              className="mt-4 px-8 py-3 bg-amber-500 font-semibold rounded-full hover:bg-amber-600 transition-colors"
              disabled={saving}
            >
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </form>
        )}

        {activeTab === 'communityForms' && (
          <CommunityFormSubmissions userId={user.uid} />
        )}

        {activeTab === 'progress' && renderProgress()}
      </div>
    </>
  );
};

export default UserProfile;
